module.exports = __webpack_public_path__ + "media/images/pic/sample3-78353eebc1ff9a106c21edf9d10226dd.jpg";